var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({staticClass:"base-button",attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},'el-button',_vm.$attrs,false),[(!_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center"},[_vm._t("prefix"),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("suffix")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0410e0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/button/BaseButton.vue
// module id = null
// module chunks = 